module.exports = __webpack_public_path__ + "fonts/DINPro-CondBold.e9ff694f.ttf";